import React, { useState } from "react";
import { PrimaryButton } from "./PrimaryButton";

export function Hero({ portraitSrc, scrollToSection }) {
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <section
      id="home"
      className="page-enter min-h-[calc(100vh-5rem)] scroll-mt-24 pt-28 md:pt-32"
    >
      <div className="mx-auto grid max-w-[1400px] gap-0 md:min-h-[calc(100vh-8rem)] md:grid-cols-2">
        <div className="flex flex-col justify-center px-6 py-16 md:px-12 lg:px-16">
          <h1 className="max-w-xl font-heading text-4xl font-semibold leading-tight tracking-tight text-primary md:text-5xl lg:text-[3.5rem] lg:leading-[1.1]">
            Refined Aesthetics. World-Class Expertise.
          </h1>
          <p className="mt-8 max-w-md font-body text-base font-light leading-relaxed text-ink">
            A premium plastic and aesthetic surgery practice in Cairo—where
            safety, expertise, and natural results meet a discreet, concierge
            experience.
          </p>
          <div className="mt-10">
            <PrimaryButton type="button" onClick={() => scrollToSection("services")}>
              Discover Treatments
            </PrimaryButton>
          </div>
        </div>

        <div className="relative min-h-[420px] w-full overflow-hidden bg-primary md:min-h-0">
          <img
            src={portraitSrc}
            alt="Dr. Karim Rafla, plastic and aesthetic surgeon"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            className={`h-full w-full object-cover object-center transition-opacity duration-700 ${
              imgLoaded ? "hero-image-reveal opacity-100" : "scale-105 opacity-0"
            }`}
          />
          {!imgLoaded && (
            <div
              className="absolute inset-0 bg-primary"
              aria-hidden
            />
          )}
        </div>
      </div>
    </section>
  );
}
